import { render } from "./InicioComponent.vue?vue&type=template&id=7fc9bcb4"
import script from "./InicioComponent.vue?vue&type=script&lang=js"
export * from "./InicioComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__